/* Luxe collectie: filterchips (Huid/Haar/Lichaam/Binnenkant) + promotegel in het grid. */
(function () {
  function init() {
    var root = document.querySelector('[data-lx-ci]');
    var grid = document.getElementById('product-grid');
    if (!root || !grid) return;
    var items = Array.prototype.slice.call(grid.children).filter(function (li) { return li.querySelector('.lx-card'); });
    function catsOf(li) { var c = li.querySelector('.lx-card'); return c ? (c.getAttribute('data-lx-cat') || '').trim().split(/\s+/).filter(Boolean) : []; }

    // promotegel na de 2e kaart, alleen als het promoproduct in deze collectie zit
    var tpl = root.querySelector('template[data-lx-promo]');
    var promo = null;
    if (tpl && grid.querySelector('.lx-card[data-lx-handle="' + tpl.getAttribute('data-handle') + '"]')) {
      promo = tpl.content.firstElementChild.cloneNode(true);
      if (items[0]) promo.className = items[0].className.replace('aos-init', '').replace('aos-animate', '') + ' lx-promo-item';
      promo.setAttribute('data-lx-promo-cat', tpl.getAttribute('data-cat') || '');
      var after = items[Math.min(1, items.length - 1)];
      if (after) after.after(promo);
    }

    // chips: alleen tonen als er minstens 2 categorieën met producten zijn
    var chipsWrap = root.querySelector('[data-lx-chips]');
    var chips = Array.prototype.slice.call(chipsWrap.querySelectorAll('.lx-chip'));
    var used = 0;
    chips.forEach(function (ch) {
      var cat = ch.getAttribute('data-cat');
      if (!cat) return;
      var n = items.filter(function (li) { return catsOf(li).indexOf(cat) >= 0; }).length;
      if (!n) ch.remove(); else { used++; ch.insertAdjacentHTML('beforeend', ' <span>' + n + '</span>'); }
    });
    if (used >= 2) chipsWrap.hidden = false;

    function apply(cat) {
      chipsWrap.querySelectorAll('.lx-chip').forEach(function (ch) { ch.setAttribute('aria-pressed', String(ch.getAttribute('data-cat') === cat)); });
      items.forEach(function (li) { li.hidden = !!cat && catsOf(li).indexOf(cat) < 0; });
      if (promo) { var pc = promo.getAttribute('data-lx-promo-cat'); promo.hidden = !!cat && pc.split(' ').indexOf(cat) < 0; }
      try { var u = new URL(location.href); if (cat) u.searchParams.set('lx', cat); else u.searchParams.delete('lx'); history.replaceState(null, '', u); } catch (e) {}
    }
    chipsWrap.addEventListener('click', function (e) {
      var ch = e.target.closest('.lx-chip'); if (!ch) return;
      apply(ch.getAttribute('data-cat'));
    });
    var start = new URLSearchParams(location.search).get('lx');
    if (start && chipsWrap.querySelector('.lx-chip[data-cat="' + start + '"]')) apply(start);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
